import { buildPrompt } from '@/ai/utils/promptBuilder'
import { systemMessages } from '@/ai/prompts/common/systemMessages'
import { createUserMessage, createSystemMessage } from '@/ai/utils/promptUtils'

export const buildDescriptionValidatorPrompt = ({ workflow }) => {
  const messages = []

  messages.push(createSystemMessage(systemMessages.EVENT_MODELING_DDD_EXPERT))

  const promptSections = []

  promptSections.push({
    title: 'Request',
    content: `
      Evaluate if the following description, wrapped in curly braces, can be
      used as a description of some kind of business process, workflow, project scope
      or a description of a business information system: { ${workflow.aiDescription} }
    `
  })

  promptSections.push({
    title: 'Answer',
    content: `
      The answer must be in JSON according the the two examples under Formatting below.
      The answer must always be in English, regardless of the language in which the description is written.
    `
  })

  promptSections.push({
    title: 'Formatting',
    content: 'See two examples below.',
    spacingAfter: 1
  })

  const validDescription = { answer: 'yes' }
  const invalidDescription = { answer: 'no', 'did you mean': 'suggestion' }

  promptSections.push({
    contentType: 'codeblock',
    language: 'json',
    content: JSON.stringify(validDescription),
    spacingAfter: 1
  })

  promptSections.push({
    contentType: 'codeblock',
    language: 'json',
    content: JSON.stringify(invalidDescription)
  })

  promptSections.push({
    title: 'Notes',
    contentType: 'bullet',
    content: [
      'If you are not sure, rather answer yes than no',
      'Only answer with JSON.',
      'If the answer is no, then if possible provide a likely interpretation or better suggestion in "did you mean"',
      'Exclude backticks when generating the JSON output'
    ]
  })

  const userContent = buildPrompt(promptSections)
  messages.push(createUserMessage(userContent))

  return messages
}
